// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FaqGenerateLink_wrapper__1k0E7","select":"FaqGenerateLink_select__120vt","input":"FaqGenerateLink_input__2YzQj","radio":"FaqGenerateLink_radio__1T-tV"};